<template>
  <div class="wrapper">
    <router-view></router-view>
    <loader :isVisible="isLoading" />

    <div class="animated fadeIn">
      <ClientsProspectsFilters
        type="client"
        :initial-filter="initialFilter"
        :commercials="commercials"
        :concepts="concepts"
        @applyFilters="applyFilters"
        @addNew="showNewClientModal = true"
      />

      <div class="card" v-if="['clients-list'].indexOf($route.name) > -1">
        <div class="card-block">
          <tabs v-model="activeTab" @input="handleNewActiveTab">
            <tab :header="allHeader">
              <Clients
                :clients="clients.all"
                :rows="limit"
                :totalClients="totals.all"
                :page="page"
                :sorting="sorting"
                @archiveClient="archiveClientModalShow"
                @showComment="displayComment"
                @changePage="changePage"
                @sort="sortClients"
              />
            </tab>

            <tab :header="activeHeader">
              <Clients
                :clients="clients.active"
                :rows="limit"
                :totalClients="totals.active"
                :page="page"
                :sorting="sorting"
                @archiveClient="archiveClientModalShow"
                @showComment="displayComment"
                @changePage="changePage"
                @sort="sortClients"
              />
            </tab>

            <tab :header="inactiveHeader">
              <Clients
                :clients="clients.inactive"
                :rows="limit"
                :totalClients="totals.inactive"
                :page="page"
                :sorting="sorting"
                @archiveClient="archiveClientModalShow"
                @showComment="displayComment"
                @changePage="changePage"
                @sort="sortClients"
              />
            </tab>

            <tab :header="lastInactiveHeader">
              <Clients
                :clients="clients.lastInactive"
                :rows="limit"
                :totalClients="totals.lastInactive"
                :page="page"
                :sorting="sorting"
                @archiveClient="archiveClientModalShow"
                @showComment="displayComment"
                @changePage="changePage"
                @sort="sortClients"
              />
            </tab>

            <tab :header="inactiveFinishedPackHeader">
              <Clients
                :clients="clients.inactiveFinishedPack"
                :rows="limit"
                :totalClients="totals.inactiveFinishedPack"
                :page="page"
                :sorting="sorting"
                @archiveClient="archiveClientModalShow"
                @showComment="displayComment"
                @changePage="changePage"
                @sort="sortClients"
              />
            </tab>

            <tab :header="suspendedHeader">
              <Clients
                :clients="clients.suspended"
                :rows="limit"
                :totalClients="totals.suspended"
                :page="page"
                :sorting="sorting"
                @archiveClient="archiveClientModalShow"
                @showComment="displayComment"
                @changePage="changePage"
                @sort="sortClients"
              />
            </tab>

            <tab :header="lostHeader">
              <Clients
                :clients="clients.lost"
                :rows="limit"
                :totalClients="totals.lost"
                :page="page"
                :sorting="sorting"
                @archiveClient="archiveClientModalShow"
                @showComment="displayComment"
                @changePage="changePage"
                @sort="sortClients"
              />
            </tab>
          </tabs>
        </div>
      </div>
    </div>

    <modal
      title="Archiver un client"
      v-model="archiveClientModal.display"
      cancelText="Fermer"
      okText="Archiver"
      @ok="archiveClient()"
      effect="fade/zoom"
    >
      <div v-if="archiveClientModal.client">
        <p>
          Voulez-vous vraiment archiver le client
          <strong
            >{{ archiveClientModal.client.firstName }}
            {{ archiveClientModal.client.lastName }}
          </strong>
          ?
        </p>
      </div>
    </modal>

    <NewClientModal
      :show="showNewClientModal"
      :default="form"
      :commercials="commercials"
      :concepts="concepts"
      @close="showNewClientModal = false"
    />

    <ClientNoteModal
      :show="modalUpdateNote.show"
      :client="modalUpdateNote.client"
      @close="modalUpdateNote.show = false"
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

import Loader from "@/components/utils/Loader";
import Clients from "@/components/client/Clients";
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";
import ClientsProspectsFilters from "@/components/client/ClientsProspectsFilters";
import Modal from "vue-strap/src/Modal";
import NewClientModal from "@/components/modal/NewClientModal";
import ClientNoteModal from "@/components/client/ClientNoteModal";

export default {
  components: {
    Clients,
    Loader,
    Tabs,
    Tab,
    ClientsProspectsFilters,
    Modal,
    NewClientModal,
    ClientNoteModal,
  },

  data() {
    return {
      activeTab: 0,
      clients: {
        all: null,
        active: null,
        inactive: null,
        lastInactive: null,
        suspended: null,
        lost: null,
        inactiveFinishedPack: null,
      },
      totals: {
        all: 0,
        active: 0,
        inactive: 0,
        lastInactive: 0,
        suspended: 0,
        lost: 0,
        inactiveFinishedPack: 0,
      },
      newClient: false,
      form: {
        email: null,
        password: null,
        commercial: null,
        status: "active",
        prospect: null,
      },
      page: 1,
      offset: 0,
      limit: 15,
      countClients: true,
      getTotal: true,
      isLoading: false,
      filter: {
        begin: moment().startOf("month").toDate(),
        end: moment().endOf("day").toDate(),
        archives: "hidden",
        name: undefined,
        concepts: [],
        commercials: [],
        aiStatus: "all",
        isB2B: false,
      },
      sorting: {
        prop: "createdAt",
        order: "descending",
      },
      initialFilter: {},
      commercials: [],
      archiveClientModal: {
        display: false,
        client: null,
      },
      showNewClientModal: false,
      modalUpdateNote: {
        show: false,
        client: null,
      },
    };
  },

  computed: {
    ...mapState(["concepts"]),

    clientStatus() {
      switch (this.activeTab) {
        case 0:
          return "all";
        case 1:
          return "active";
        case 2:
          return "inactive";
        case 3:
          return "lastInactive";
        case 4:
          return "inactiveFinishedPack";
        case 5:
          return "suspended";
        case 6:
          return "lost";
        default:
          return null;
      }
    },

    allHeader() {
      return `<i class="icon-user"></i> Tous ${
        this.totals.all !== 0 ? "(" + this.totals.all + ")" : ""
      }`;
    },

    activeHeader() {
      return `<i class="icon-user"></i> Actif ${
        this.totals.active !== 0 ? "(" + this.totals.active + ")" : ""
      }`;
    },

    lastInactiveHeader() {
      return `<i class="icon-user"></i> Inactif -30J ${
        this.totals.lastInactive !== 0
          ? "(" + this.totals.lastInactive + ")"
          : ""
      }`;
    },

    inactiveHeader() {
      return `<i class="icon-user"></i> Inactif ${
        this.totals.inactive !== 0 ? "(" + this.totals.inactive + ")" : ""
      }`;
    },

    suspendedHeader() {
      return `<i class="icon-user"></i> Bloqué ${
        this.totals.suspended !== 0 ? "(" + this.totals.suspended + ")" : ""
      }`;
    },

    lostHeader() {
      return `<i class="icon-user"></i> Perdu ${
        this.totals.lost !== 0 ? "(" + this.totals.lost + ")" : ""
      }`;
    },

    inactiveFinishedPackHeader() {
      return `<i class="icon-user"></i> Inactif pack fini -30J${
        this.totals.inactiveFinishedPack !== 0
          ? "(" + this.totals.inactiveFinishedPack + ")"
          : ""
      }`;
    },
  },

  async created() {
    await this.getCommercials();

    let activeTab =
      this.$route.query.tab ?? sessionStorage.getItem("clientsTab");

    if (activeTab && this.activeTab !== parseInt(activeTab)) {
      this.activeTab = parseInt(activeTab);
    }

    if (this.$route.query.page !== undefined) {
      this.page = parseInt(this.$route.query.page);
      this.offset = this.limit * this.page - this.limit;

      this.totals = Object.fromEntries(
        this.$route.query.totals.map(([key, value]) => [key, parseInt(value)]),
      );
      this.countClients = !!this.$route.query.count;
      this.getTotal = !!this.$route.query.getTotal;

      let commercials = [];
      let concepts = [];

      if (this.$route.query.commercials) {
        commercials = Array.isArray(this.$route.query.commercials)
          ? this.$route.query.commercials
          : [this.$route.query.commercials];
      }

      if (this.$route.query.concepts) {
        concepts = Array.isArray(this.$route.query.concepts)
          ? this.$route.query.concepts
          : [this.$route.query.concepts];
      }

      this.filter = {
        archives: this.$route.query.archives || "hidden",
        concepts: concepts
          .map((c) => this.concepts.find((concept) => concept.name === c))
          .filter((c) => c),
        commercials: commercials
          .map((c) =>
            this.commercials.find((commercial) => commercial.value === c),
          )
          .filter((c) => c),
        name: this.$route.query.name || "",
        aiStatus: this.$route.query.aiStatus || "all",
        isB2B: this.$route.query.isB2B || false,
        begin: this.$route.query.begin
          ? moment(this.$route.query.begin).toDate()
          : undefined,
        end: this.$route.query.end
          ? moment(this.$route.query.end).toDate()
          : undefined,
      };

      this.sorting = {
        prop: this.$route.query.sortingProp || "createdAt",
        order: this.$route.query.sortingOrder || "descending",
      };

      this.initialFilter = { ...this.filter };

      this.getClients(this.offset);
    } else {
      const currentCommercial = this.commercials.find(
        (c) => c.value === this.$store.state.user.email,
      );

      if (currentCommercial) {
        this.filter.commercials = [currentCommercial];
        this.form.commercial = currentCommercial;
      }

      this.initialFilter = { ...this.filter };
    }
  },

  methods: {
    async getClients(offset) {
      try {
        this.isLoading = true;

        let filter = {
          ...this.filter,
          commercials: this.filter.commercials.map(({ value }) => value),
          concepts: this.filter.concepts.map((c) => c.name),
        };

        if (this.$route.query.coachId) {
          filter.coachId = this.$route.query.coachId;
        } else if (this.$route.query.coachEmpty) {
          filter.coachEmpty = this.$route.query.coachEmpty;
        }

        const { data } = await this.$api.get("/clients/info", {
          params: {
            filter: {
              ...filter,
              status: this.clientStatus,
            },
            sorting: this.sorting,
            offset,
            limit: this.limit,
            count: this.countClients,
            currentTotals: this.totals,
            getTotal: this.getTotal,
          },
        });

        this.totals = data.totals;

        switch (this.clientStatus) {
          case "all":
            this.clients.all = data.data;
            break;
          case "active":
            this.clients.active = data.data;
            break;
          case "inactive":
            this.clients.inactive = data.data;
            break;
          case "lastInactive":
            this.clients.lastInactive = data.data;
            break;
          case "suspended":
            this.clients.suspended = data.data;
            break;
          case "lost":
            this.clients.lost = data.data;
            break;
          case "inactiveFinishedPack":
            this.clients.inactiveFinishedPack = data.data;
            break;
        }

        this.countClients = false;
        this.getTotal = false;
      } catch (e) {
        this.$router.push({
          name: "dashboard",
        });
      } finally {
        this.isLoading = false;
      }
    },

    async applyFilters(form) {
      this.filter = {
        ...this.filter,
        ...form,
      };
      this.countClients = true;

      await this.changePage(1);
    },

    async getCommercials() {
      try {
        this.isLoading = true;

        const { data } = await this.$api.get("/users/commercials/search");

        this.commercials = data.map((c) => ({
          value: c.email,
          label: c.commercial.pseudo,
          color: c.commercial.color,
          data: c,
        }));
      } catch (e) {
        this.commercials = [];
      } finally {
        this.isLoading = false;
      }
    },

    handleNewClient() {
      this.$emit("handleClient", this.form);
    },

    archiveClientModalShow(client) {
      this.archiveClientModal.display = true;
      this.archiveClientModal.client = client;
    },

    async archiveClient() {
      await this.$api.put("/clients", {
        email: this.archiveClientModal.client.email,
        archived: true,
      });

      this.archiveClientModal.client.archived = true;
      this.archiveClientModal.display = false;
      this.countClients = true;
    },

    displayComment(client) {
      this.modalUpdateNote = {
        ...this.modalUpdateNote,
        client,
        show: true,
      };
    },

    async changePage(page) {
      this.$router.push({
        name: "clients-list",
        query: {
          page,
          count: this.countClients,
          tab: this.activeTab,
          ...this.filter,
          begin: this.filter.begin
            ? moment(this.filter.begin).format("YYYY-MM-DD")
            : undefined,
          end: this.filter.end
            ? moment(this.filter.end).format("YYYY-MM-DD")
            : undefined,
          concepts: this.filter.concepts.map((c) => c.name),
          commercials: this.filter.commercials.map((c) => c.value),
          totals: Object.entries(this.totals),
          getTotal: this.getTotal,
          sortingProp: this.sorting.prop,
          sortingOrder: this.sorting.order,
        },
      });
    },

    async handleNewActiveTab(index) {
      this.getTotal = true;

      sessionStorage.setItem("clientsTab", index);
    },

    sortClients({ prop, order }) {
      this.sorting = { ...this.sorting, prop, order };
      this.countClients = true;

      this.changePage(1);
    },
  },
};
</script>
<style type="text/css">
.card-header .float-right {
  margin-left: 10px;
}
.switch.float-right {
  margin-left: 0;
  margin-right: 25px;
}
</style>
